var console = require("./logger.js");
var JSON = require("./json3.mod.js");
var Oop = require("./oop.js");
var FrameProxy = require("./frameproxy.js");
var DPLocksmith = require("./DPLocksmith.js");

var zeros = "0000000000000000000000000000000000000000000000000000000000000000";

var locksmith = new DPLocksmith();
locksmith.setJSON(JSON);
locksmith.setConsole(console);

function SecureFrameProxy () {

    SecureFrameProxy._parent.constructor.apply(this, arguments);
}
SecureFrameProxy.name = "SecureFrameProxy";

Oop.extend(SecureFrameProxy, FrameProxy);

SecureFrameProxy.prototype.setEnable = function (isEnable) {

    if (this._isEnable != isEnable) {

        var currentCount = this._messageCallbackTable.getCallbackCount();

        if (isEnable === true) {

            this._message(0, currentCount);

        } else {

            this._message(currentCount, 0);
        }

        this._isEnable = isEnable;
    }

    return this;
};

SecureFrameProxy.prototype.isEnable = function () {

    return this._isEnable;
};

SecureFrameProxy.prototype._isEnable = true;

SecureFrameProxy.prototype._message = function (before, after) {

    if (this.isEnable() === false) {

        console.warn(__GLOBAL_LOG_PREFIX__, "[" + this.constructor.name + "][_message] Disabled!");
        return;
    }

    SecureFrameProxy._parent._message.apply(this, arguments);
};

SecureFrameProxy.prototype.setTargetInfo = function (targetInfo) {

    SecureFrameProxy._parent.setTargetInfo.apply(this, arguments);

    this._keyPackageEnc = this._createKeyPackage(this._targetInfo.encKey);

    return this;
};

SecureFrameProxy.prototype._keyPackageEnc = {};
SecureFrameProxy.prototype._keyPackageDec = {};

SecureFrameProxy.prototype._createKeyPackage = function (key) {

    if (key == null) {

        return null;
    }

    try {

        var CryptoJS = locksmith.CryptoJS;

        var isHex = /^[0-9a-f]+$/i.test(key);

        if (isHex === false) {

            key = CryptoJS.enc.Utf8.parse(key);
            key = key.toString(CryptoJS.enc.Hex);
        }

        var byteCount = key.length / 2;
        var half = Math.ceil(byteCount / 2);
        var part1 = key.slice(0, half * 2);
        var part2 = key.slice(half * 2);

        part1 = (part1 + zeros).slice(0, 64);
        part2 = (part2 + zeros).slice(0, 64);

        return {
            Major: CryptoJS.enc.Hex.parse(part1),
            Auxiliary: CryptoJS.enc.Hex.parse(part2)
        };

    } catch(e) {

        console.error(__GLOBAL_LOG_PREFIX__, "[" + this.constructor.name + "][_createKeyPackage] Error");
    }

    return null;
};

// For decrypt incoming message
SecureFrameProxy.prototype._decKey = null;

SecureFrameProxy.prototype.setDecKey = function (decKey) {

    this._decKey = decKey;

    this._keyPackageDec = this._createKeyPackage(decKey);

    return this;
};

SecureFrameProxy.prototype.getDecKey = function () {

    return this._decKey;
};

SecureFrameProxy.prototype._cloneTargetInfo = function (infoSrc) {

    var targetInfo = SecureFrameProxy._parent._cloneTargetInfo.apply(this, arguments);

    if (targetInfo == null) {

        return null;
    }

    targetInfo.encKey = infoSrc.encKey;

    return targetInfo;
};

SecureFrameProxy.prototype._encryptString = function (plaintext) {

    var result = null;

    try {

        result = locksmith.encryptString(this._keyPackageEnc, plaintext);

    } catch(e) {

        console.error(__GLOBAL_LOG_PREFIX__, "[" + this.constructor.name + "][_encryptString] Error");
    }
    
    return result;
};

SecureFrameProxy.prototype._decryptString = function (ciphertext) {

    var result = null;

    try {

        result = locksmith.decryptString(this._keyPackageDec, ciphertext);

    } catch(e) {

        console.error(__GLOBAL_LOG_PREFIX__, "[" + this.constructor.name + "][_decryptString] Error");
    }
    
    return result;
};

SecureFrameProxy.prototype.postSecureMessage = function (messageId, message, senderId) {

    console.log(__GLOBAL_LOG_PREFIX__, "[" + this.constructor.name + "][postSecureMessage] Enter:"+messageId);

    if (this._keyPackageEnc == null) {

        console.warn(__GLOBAL_LOG_PREFIX__, "[" + this.constructor.name + "][postSecureMessage] Key not ready");
        return this;
    }

    if (messageId == null) {

        console.error(__GLOBAL_LOG_PREFIX__, "[" + this.constructor.name + "][postSecureMessage] Empty messageId");
        return this;
    }

    if (this._isTargetInfoValid() === false) {

        console.warn(__GLOBAL_LOG_PREFIX__, "[" + this.constructor.name + "][postSecureMessage] Invalid target");
        return this;
    }

    if (senderId == null) {

        senderId = this._senderId;
    }

    var targetInfo = this.getTargetInfo();

    var encMessageId = null;
    var encMessage = null;
    var isEncrypted = false;

    try {

        encMessageId = this._encryptString(messageId);

        if (message != null) {

            encMessage = this._encryptString(JSON.stringify(message));
        }
        
        isEncrypted = true;

    } catch(e) {}

    this._doPostMessage({
        targetId: targetInfo.targetId,
        messageId: encMessageId,
        message: encMessage,
        senderId: senderId,
        isEncrypted: isEncrypted
    });

    return this;
};

// interface impl.
SecureFrameProxy.prototype._doPostMessage = function (messageObject) {

    if (this.isEnable() === false) {

        console.warn(__GLOBAL_LOG_PREFIX__, "[" + this.constructor.name + "][_doPostMessage] Disabled!");
        return;
    }

    SecureFrameProxy._parent._doPostMessage.apply(this, arguments);
};

SecureFrameProxy.prototype._doMessageCallback = function (messageObject, messageProxy) {

    if (this.isEnable() === false) {

        console.warn(__GLOBAL_LOG_PREFIX__, "[" + this.constructor.name + "][_doMessageCallback] Disabled!");
        return;
    }

    messageObject.wasEncrypted = false;

    if (messageObject.isEncrypted === true) {

        var decMessageId = null;
        var decMessage = null;

        try {

            if (this._keyPackageDec != null) {

                decMessageId = this._decryptString(messageObject.messageId);

                if (messageObject.message != null) {

                    decMessage = JSON.parse(this._decryptString(messageObject.message));
                }

            } else {

                console.warn(__GLOBAL_LOG_PREFIX__, "[" + this.constructor.name + "][_doMessageCallback] Key not ready");
            }

        } catch(e) {}
        
        messageObject.messageId = decMessageId;
        messageObject.message = decMessage;
        messageObject.wasEncrypted = true;
    }

    delete messageObject.isEncrypted;
    
    SecureFrameProxy._parent._doMessageCallback.apply(this, [messageObject, messageProxy]);
};

SecureFrameProxy.prototype._defaultTargetInfo = {
    targetId: "Message.Frame",
    window: null,
    origin: "*",
    // For encrypt outgoing message
    encKey: null
};

SecureFrameProxy.prototype._targetType = "SecureFrameWindow";

module.exports = SecureFrameProxy;